import React, { Component } from 'react'
import { withRouter, Route } from 'react-router-dom'
import styled from 'styled-components'
import Header from './components/Header'
import Intro from './components/Intro'
import Footer from './components/Footer'
import ProjectPage from './components/projects/ProjectPage'
import Gallery from './components/Gallery'
import projects from './projects.json'
import ServicesSummary from'./components/ServicesSummary'
import { breakpoints } from './ui-config'
import activeCustomProjects from './components/projects/active'

const StyledContentContainer = styled.div`
    min-width: 296px;
    margin: 0 auto;

    @media (max-width: ${breakpoints.small}px) {
        width: 100%;
    }
`

class ContentContainer extends Component {
    componentWillUpdate() {
        document.querySelector('html').scrollTop = 0
    }

    render() {
        return (
            <StyledContentContainer>
                <Header />
                <Route exact path="/" render={ () =>
                    <div>
                        <Intro />
                        <Gallery projects={ projects } />
                        <ServicesSummary />
                    </div>
                } />
                <Route path="/:title" render={ routeProps => {
                    const idx = activeCustomProjects.map(p => p.title).indexOf(routeProps.match.params.title)
                    if (idx > -1) {
                        const Comp = activeCustomProjects[idx].component
                        return <ProjectPage { ...routeProps} customProject={ <Comp /> } />
                    }
                    else return <ProjectPage { ...routeProps } />
                }} />
                <Footer />
            </StyledContentContainer>
        );
    }
}

export default withRouter(ContentContainer);



// WEBPACK FOOTER //
// ./src/ContentContainer.js